import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as svc from "../../api/accountHeadService";
import { getApiErrorMessage } from "../../utils/apiError";

export const fetchAccountHeads = createAsyncThunk("accountHeads/fetchAll", async (params) => {
  const res = await svc.getAccountHeads(params);
  return res.data;
});

export const createAccountHeadThunk = createAsyncThunk("accountHeads/create", async (data, { rejectWithValue }) => {
  try {
    const res = await svc.createAccountHead(data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to create account head."));
  }
});

export const updateAccountHeadThunk = createAsyncThunk("accountHeads/update", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await svc.updateAccountHead(id, data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to update account head."));
  }
});

export const deleteAccountHeadThunk = createAsyncThunk("accountHeads/delete", async (id, { rejectWithValue }) => {
  try {
    await svc.deleteAccountHead(id);
    return id;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to delete account head."));
  }
});

const accountHeadSlice = createSlice({
  name: "accountHeads",
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccountHeads.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchAccountHeads.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchAccountHeads.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createAccountHeadThunk.fulfilled, (state, action) => { state.list.push(action.payload); })
      .addCase(updateAccountHeadThunk.fulfilled, (state, action) => {
        const id = action.payload.accountID || action.payload.id;
        const idx = state.list.findIndex((a) => (a.accountID || a.id) === id);
        if (idx !== -1) state.list[idx] = action.payload;
      })
      .addCase(deleteAccountHeadThunk.fulfilled, (state, action) => {
        state.list = state.list.filter((a) => (a.accountID || a.id) !== action.payload);
      });
  },
});

export default accountHeadSlice.reducer;
